import { Id } from "PFTypes/id";

export const certificateKeys = {
  all: () => ["certificates"],
  list: (profileId: Id, page: number, perPage: number, customValueIds: Id[]) => [
    ...certificateKeys.all(),
    profileId,
    page,
    perPage,
    customValueIds
  ],
  single: (id: Id) => ["certificate", id.toString()]
};
